import {
  V2PageType,
  type V2ContactPageType,
  type V2ReservationsPageType,
} from '@Src/middlewares/CustomPageTypes';
import Grid from '@mui/material/Grid';
import { StyledPaddedSection } from '../../WebsiteV2/Common/StyledSection';

import { styled } from '@mui/material/styles';

import Typography from '@mui/material/Typography';
import { useIsMobile } from '@Src/hooks/useIsMobile';
import ContactFormWidget from '@Components/Widgets/ContactForms/ContactFormWidget';
import ReservationsFormWidget from '@Components/Widgets/ContactForms/ReservationsFormWidget';
import LocationsWidget from '@Components/Widgets/Locations';

const StyledTitle = styled(Typography)`
  padding-bottom: ${({ theme }) => theme.spacing(6)};
  ${({ theme }) => theme.breakpoints.down('sm')} {
    padding-bottom: 0;
  }
`;

const StyledPadding = styled(StyledPaddedSection)`
  ${({ theme }) => theme.breakpoints.down('sm')} {
    padding-top: ${({ theme }) => theme.spacing(2)};
    padding-left: ${({ theme }) => theme.spacing(2)};
    padding-right: ${({ theme }) => theme.spacing(2)};
  }
`;

const StyledLocationsGrid = styled(Grid)`
  padding-top: ${({ theme }) => theme.spacing(8)};
  ${({ theme }) => theme.breakpoints.up('sm')} {
    padding-top: ${({ theme }) => theme.spacing(6)};
    padding-bottom: ${({ theme }) => theme.spacing(6)};
  }
`;

const StyledPageContainer = styled('div')`
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const Contact = ({
  data,
}: {
  data: V2ContactPageType | V2ReservationsPageType;
}): JSX.Element => {
  const isMobile = useIsMobile();
  return (
    <StyledPageContainer>
      <StyledPadding>
        <Grid container>
          <Grid item xs={12}>
            <StyledTitle variant={isMobile ? 'h2Display' : 'h1'}>
              {data?.title || ''}
            </StyledTitle>
          </Grid>
          {data.pageType === V2PageType.ContactPage && (
            <ContactFormWidget contactFormData={data} />
          )}
          {data.pageType === V2PageType.ReservationsPage && (
            <ReservationsFormWidget reservationsData={data} />
          )}
          {data.locationsEnabled && (
            <StyledLocationsGrid item xs={12}>
              <LocationsWidget />
            </StyledLocationsGrid>
          )}
        </Grid>
      </StyledPadding>
    </StyledPageContainer>
  );
};

export default Contact;
